var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderOrderMain',{attrs:{"img_header":_vm.img_holder,"header":"แก้ไขใบตรวจสอบเข้าคลัง (Modify order status control)","link_back":"ordermain/ordercontrollist"}}),_c('v-card',{staticClass:"pa-5",staticStyle:{"border":"black solid 1px"},attrs:{"elevation":"0"}},[_c('ControlMenuEdit'),_c('Edit_order_status')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }